// import { useState, useEffect } from "react";
// import { yupResolver } from "@hookform/resolvers/yup";
// import { useMutation, useQuery } from "@tanstack/react-query";
// import { toast } from "react-toastify";
// import { useQueryClient } from "@tanstack/react-query";
// import ReactQuill from "react-quill";
// import { useForm, Controller } from "react-hook-form";
// import Checkbox from "../../ChildComponents/Checkbox";
// import SmartImageUpload from "../../ChildComponents/SmartImageUploader";
// import Input from "../../ChildComponents/Input";
// import BrandButton from "../../ChildComponents/BrandButton";
// import Select from "../../ChildComponents/Select";
// import Label from "../../ChildComponents/Label";
// import { newsSchema } from "../validation/newsValidation";
// import { useGetlocation } from "../../store/api/locationApi";
// import { useGetCategory } from "../../store/api/categoryApi";
// import { useGetTopic } from "../../store/api/topicApi";
// import { useGetUser } from "../../store/api/authApi";
// import { useCreateNews, useUpdateNews } from "../../store/api/newsApi";

// function RoleForm({ data, editId, onSuccessCreated }) {
//   const getLocalDateTime = () => {
//     const now = new Date();
//     const year = now.getFullYear();
//     const month = String(now.getMonth() + 1).padStart(2, "0");
//     const day = String(now.getDate()).padStart(2, "0");
//     const hours = String(now.getHours()).padStart(2, "0");
//     const minutes = String(now.getMinutes()).padStart(2, "0");
//     return `${year}-${month}-${day}T${hours}:${minutes}`;
//   };

//   const formattedNow = getLocalDateTime();

//   const modules = {
//     toolbar: [
//       // Font and Size
//       [{ font: [] }],
//       [{ size: ["small", false, "large", "huge"] }],

//       // Headers
//       [{ header: [1, 2, 3, 4, 5, 6, false] }],

//       // Text formatting
//       ["bold", "italic", "underline", "strike"],

//       // Text color and background color
//       [{ color: [] }, { background: [] }],

//       // Subscript/Superscript
//       [{ script: "sub" }, { script: "super" }],

//       // Lists
//       [{ list: "ordered" }, { list: "bullet" }],
//       [{ indent: "-1" }, { indent: "+1" }],

//       // Text alignment
//       [{ align: [] }],

//       // Direction
//       [{ direction: "rtl" }],

//       // Links, Images, Videos
//       ["link", "image", "video"],

//       // Code block and Blockquote
//       ["blockquote", "code-block"],

//       // Clean formatting
//       ["clean"],
//     ],
//     clipboard: {
//       matchVisual: false,
//     },
//   };

//   const formats = [
//     "header",
//     "font",
//     "size",
//     "bold",
//     "italic",
//     "underline",
//     "strike",
//     "blockquote",
//     "list",
//     "bullet",
//     "indent",
//     "link",
//     "image",
//     "video",
//     "color",
//     "background",
//     "align",
//     "direction",
//     "code-block",
//     "script",
//   ];

//   const getUser = useGetUser();
//   const {
//     data: userData,
//     isLoading: isUserLoading,
//     error: UserError,
//   } = useQuery({ queryKey: "users", queryFn: getUser });

//   const transformedUser = userData?.user?.map((user) => ({
//     label: user.fullName,
//     value: user._id,
//   }));

//   const getLocation = useGetlocation();
//   const {
//     data: locationData,
//     isLoading: isLocationLoading,
//     error: locationError,
//   } = useQuery({ queryKey: "location", queryFn: getLocation });

//   const transformedDivistion = locationData?.division?.map((i) => ({
//     label: i.name,
//     value: i._id,
//     myId: i.id,
//   }));
//   const transformedDistrict = locationData?.district?.map((i) => ({
//     label: i.name,
//     value: i._id,
//     dId: i.division_id,
//     myid: i.id,
//   }));
//   const transformedSubDistrict = locationData?.upazila?.map((i) => ({
//     label: i.name,
//     value: i._id,
//     dId: i.district_id,
//     myid: i.id,
//   }));
//   const transformedStatus = [
//     { value: "active", label: "Active" },
//     { value: "inactive", label: "Inactive" },
//   ];

//   const getCategory = useGetCategory();
//   const {
//     data: categoryhData,
//     isLoading: isCategoryLoading,
//     error: categoryError,
//   } = useQuery({ queryKey: "category", queryFn: getCategory });

//   const getTopic = useGetTopic();
//   const {
//     data: topicData,
//     isLoading: istopicLoading,
//     error: topicError,
//   } = useQuery({ queryKey: "topic", queryFn: getTopic });

//   const transformedTopics = topicData?.topics?.map((topic) => ({
//     label: topic.name,
//     value: topic._id,
//   }));

//   const updateNews = useUpdateNews(editId?._id);

//   const {
//     register,
//     handleSubmit,
//     control,
//     formState: { errors },
//     reset,
//     watch,
//   } = useForm({
//     resolver: yupResolver(newsSchema),
//     defaultValues: {
//       dateTime: formattedNow, // <= default date & time
//     },
//   });

//   useEffect(() => {
//     if (editId) {
//       const selectedDivision = transformedDivistion?.find(
//         (item) => item.value === editId.division
//       );
//       const selectedDistrict = transformedDistrict?.find(
//         (item) => item.value === editId.district
//       );
//       const selectedSubDistrict = transformedSubDistrict?.find(
//         (item) => item.value === editId.upazila
//       );
//       const selectedReporter = transformedUser?.find(
//         (item) => item.value === editId.reporters
//       );
//       console.log(selectedReporter);
//       const selectedStatus = transformedStatus?.find(
//         (item) => item.value === editId.status
//       );

//       const selectedCategories =
//         editId.categoryList?.map((cat) => cat._id) || [];

//       const selectedTopic = editId.topicList?.filter((catId) =>
//         topicData?.categorys?.some((cat) => cat._id === catId)
//       );

//       reset({
//         title: editId.title || "",
//         subTitle: editId.subTitle || "",
//         division: selectedDivision || null,
//         district: selectedDistrict || null,
//         subDistrict: selectedSubDistrict || null,
//         repoters: selectedReporter || null,
//         status: selectedStatus || null,
//         selectedCategories: selectedCategories || [],
//         selectedTopic: selectedTopic || [],
//         description: editId.discription || "",
//         seoTitle: editId.metaTitle || "",
//         metaDescription: editId.metaDiscription || "",
//         image: editId.image ? `${editId.image}` : null,
//         leadNews: editId.leadNews || false,
//         liveNews: editId.liveNews || false,
//         categoryPin: editId.categoryPin || false,
//         topNews: editId.topNews || false,
//         dateTime: editId.publishDate
//           ? new Date(editId.publishDate).toISOString().slice(0, 16)
//           : formattedNow,
//       });

//       setEdited(true);
//     }
//   }, [editId, reset]);

//   useEffect(() => {
//     if (!editId) {
//       // Reset form to blank
//       reset({
//         title: "",
//         subTitle: "",
//         division: null,
//         district: null,
//         subDistrict: null,
//         repoters: null,
//         status: null,
//         selectedCategories: [],
//         selectedTopic: [],
//         description: "",
//         seoTitle: "",
//         metaDescription: "",
//         image: null,
//         leadNews: false,
//         liveNews: false,
//         categoryPin: false,
//         topNews: false,
//         dateTime: formattedNow,
//       });
//       setEdited(false);
//     }
//   }, [editId, reset]);

//   const createNews = useCreateNews();
//   const queryClient = useQueryClient();
//   const [loading, setLoading] = useState(false);
//   const [edited, setEdited] = useState(editId ? true : false);

//   const mutation = useMutation({
//     mutationFn: (data) => {
//       return editId ? updateNews(data) : createNews(data);
//     },
//     onSuccess: (data) => {
//       queryClient.invalidateQueries(["news"]);
//       setLoading(false);
//       toast.success("Created Successfully");
//       reset();
//       onSuccessCreated(1);
//     },
//     onError: (error) => {
//       toast.error(error.message || "Something went wrong!");
//       setLoading(false);
//     },
//   });

//   const onSubmit = (formData) => {
//     setLoading(true);
//     try {
//       const data = new FormData();

//       if (!formData.title?.trim()) {
//         toast.warning("Title is required!");
//         setLoading(false);
//         return;
//       }

//       if (!formData.repoters || !formData.repoters.value) {
//         toast.warning("Reporter is required!");
//         setLoading(false);
//         return;
//       }

//       if (!formData.description?.trim()) {
//         toast.warning("Description is required!");
//         setLoading(false);
//         return;
//       }

//       if (
//         !formData.selectedCategories ||
//         formData.selectedCategories.length === 0
//       ) {
//         toast.warning("At least one category is required!");
//         setLoading(false);
//         return;
//       }

//       if (!formData.image) {
//         toast.warning("Image is required!");
//         setLoading(false);
//         return;
//       }

//       data.append("title", formData.title);
//       data.append("reporters", formData.repoters.value);
//       data.append("discription", formData.description);
//       formData.selectedCategories.forEach((catId) => {
//         data.append("categoryList", catId);
//       });
//       data.append("image", formData.image);

//       if (formData.subTitle) data.append("subTitle", formData.subTitle);
//       if (formData.selectedTopic?.length > 0) {
//         formData.selectedTopic.forEach((catId) => {
//           data.append("topicList", catId);
//         });
//       }
//       if (formData.seoTitle) data.append("metaTitle", formData.seoTitle);
//       if (formData.metaDescription)
//         data.append("metaDiscription", formData.metaDescription);
//       if (formData.division?.value)
//         data.append("division", formData.division.value);
//       if (formData.district?.value)
//         data.append("district", formData.district.value);
//       if (formData.subDistrict?.value)
//         data.append("upazila", formData.subDistrict.value);
//       if (formData.status?.value) data.append("status", formData.status.value);
//       data.append("leadNews", formData.leadNews);
//       data.append("liveNews", formData.liveNews);
//       data.append("categoryPin", formData.categoryPin);
//       data.append("topNews", formData.topNews);
//       data.append("dateTime", formData.dateTime);

//       mutation.mutate(data);
//     } catch (error) {
//       setLoading(false);
//       console.error("Caught error in handleSubmit:", error.message);
//       toast.error(error.message);
//     }
//   };

//   return (
//     <div
//       className="container-fluid"
//       style={{
//         background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
//         minHeight: "100vh",
//         padding: "2rem 0",
//       }}
//     >
//       <div className="container-fluid">
//         {/* Header */}
//         <div className="mb-5">
//           <h1 className="display-4 fw-bold text-dark mb-2">
//             {editId ? "✏️ Edit News Article" : "📝 Create News Article"}
//           </h1>
//           <p className="lead text-muted">
//             Fill in the details to publish your news story
//           </p>
//         </div>

//         <form onSubmit={handleSubmit(onSubmit)}>
//           <div className="row g-4">
//             {/* Main Content Area - Left Column */}
//             <div className="col-lg-8">
//               {/* Title Section Card */}
//               <div
//                 className="card shadow-lg border-0 mb-4"
//                 style={{ borderRadius: "20px", overflow: "hidden" }}
//               >
//                 <div
//                   className="card-header text-white py-3"
//                   style={{
//                     background:
//                       "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                   }}
//                 >
//                   <h5 className="mb-0 d-flex align-items-center">
//                     <i className="bi bi-pencil-square me-2"></i>
//                     Article Details
//                   </h5>
//                 </div>
//                 <div className="card-body p-4">
//                   <div className="row g-3">
//                     <div className="col-12">
//                       <Input
//                         icon="title"
//                         {...register("title")}
//                         error={errors.name?.message}
//                         type="text"
//                         placeholder="Enter compelling news title..."
//                         label="News Title"
//                       />
//                     </div>

//                     <div className="col-12">
//                       <Input
//                         icon="title"
//                         {...register("subTitle")}
//                         error={errors.name?.message}
//                         type="text"
//                         placeholder="Add subtitle for context..."
//                         label="News Subtitle"
//                       />
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Status Toggles Card */}
//               <div
//                 className="card shadow-lg border-0 mb-4"
//                 style={{ borderRadius: "20px", overflow: "hidden" }}
//               >
//                 <div
//                   className="card-header text-white py-3"
//                   style={{
//                     background:
//                       "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
//                   }}
//                 >
//                   <h5 className="mb-0 d-flex align-items-center">
//                     <i className="bi bi-toggles me-2"></i>
//                     Publication Settings
//                   </h5>
//                 </div>
//                 <div className="card-body p-4">
//                   <div className="row g-4">
//                     <div className="col-md-6 col-lg-3">
//                       <div className="p-3 bg-light rounded-3 h-100">
//                         <Controller
//                           name="leadNews"
//                           control={control}
//                           defaultValue={false}
//                           render={({ field }) => (
//                             <Checkbox
//                               id="leadNews"
//                               title=" Lead News"
//                               checked={field.value}
//                               onChange={(e) => field.onChange(e.target.checked)}
//                             />
//                           )}
//                         />
//                       </div>
//                     </div>
//                     <div className="col-md-6 col-lg-3">
//                       <div className="p-3 bg-light rounded-3 h-100">
//                         <Controller
//                           name="liveNews"
//                           control={control}
//                           defaultValue={false}
//                           render={({ field }) => (
//                             <Checkbox
//                               id="liveNews"
//                               title=" Live News"
//                               checked={field.value}
//                               onChange={(e) => field.onChange(e.target.checked)}
//                             />
//                           )}
//                         />
//                       </div>
//                     </div>
//                     <div className="col-md-6 col-lg-3">
//                       <div className="p-3 bg-light rounded-3 h-100">
//                         <Controller
//                           name="categoryPin"
//                           control={control}
//                           defaultValue={false}
//                           render={({ field }) => (
//                             <Checkbox
//                               id="CategoryPin"
//                               title=" Category Pin"
//                               checked={field.value}
//                               onChange={(e) => field.onChange(e.target.checked)}
//                             />
//                           )}
//                         />
//                       </div>
//                     </div>
//                     <div className="col-md-6 col-lg-3">
//                       <div className="p-3 bg-light rounded-3 h-100">
//                         <Controller
//                           name="topNews"
//                           control={control}
//                           defaultValue={false}
//                           render={({ field }) => (
//                             <Checkbox
//                               id="topNews"
//                               title=" Top News"
//                               checked={field.value}
//                               onChange={(e) => field.onChange(e.target.checked)}
//                             />
//                           )}
//                         />
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Location Section Card */}
//               <div
//                 className="card shadow-lg border-0 mb-4"
//                 style={{ borderRadius: "20px", overflow: "hidden" }}
//               >
//                 <div
//                   className="card-header text-white py-3"
//                   style={{
//                     background:
//                       "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
//                   }}
//                 >
//                   <h5 className="mb-0 d-flex align-items-center">
//                     <i className="bi bi-geo-alt me-2"></i>
//                     Location Information
//                   </h5>
//                 </div>
//                 <div className="card-body p-4">
//                   <div className="row g-3">
//                     <div className="col-md-4">
//                       <Controller
//                         name="division"
//                         control={control}
//                         render={({ field }) => (
//                           <Select
//                             {...field}
//                             isClearable
//                             options={transformedDivistion}
//                             placeholder="Select a Division"
//                             label="Division"
//                             menuPortalTarget={document.body}
//                             styles={{
//                               menuPortal: (base) => ({ ...base, zIndex: 9999 }),
//                             }}
//                           />
//                         )}
//                       />
//                     </div>
//                     <div className="col-md-4">
//                       <Controller
//                         name="district"
//                         control={control}
//                         render={({ field }) => (
//                           <Select
//                             {...field}
//                             isClearable
//                             options={transformedDistrict?.filter(
//                               (district) =>
//                                 !watch("division") ||
//                                 district?.dId === watch("division")?.myId
//                             )}
//                             placeholder="Select a District"
//                             label="District"
//                             menuPortalTarget={document.body}
//                             styles={{
//                               menuPortal: (base) => ({ ...base, zIndex: 9999 }),
//                             }}
//                           />
//                         )}
//                       />
//                     </div>
//                     <div className="col-md-4">
//                       <Controller
//                         name="subDistrict"
//                         control={control}
//                         render={({ field }) => (
//                           <Select
//                             {...field}
//                             isClearable
//                             options={transformedSubDistrict?.filter(
//                               (upazila) =>
//                                 !watch("district") ||
//                                 upazila?.dId === watch("district")?.myid
//                             )}
//                             placeholder="Select an Upazila"
//                             label="Upazila"
//                             menuPortalTarget={document.body}
//                             styles={{
//                               menuPortal: (base) => ({ ...base, zIndex: 9999 }),
//                             }}
//                           />
//                         )}
//                       />
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Content Editor Card */}
//               <div
//                 className="card shadow-lg border-0 mb-4"
//                 style={{ borderRadius: "20px", overflow: "hidden" }}
//               >
//                 <div
//                   className="card-header text-white py-3"
//                   style={{
//                     background:
//                       "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
//                   }}
//                 >
//                   <h5 className="mb-0 d-flex align-items-center">
//                     <i className="bi bi-file-text me-2"></i>
//                     Article Content
//                   </h5>
//                 </div>
//                 <div className="card-body p-4">
//                   <Label className="fw-bold mb-2" label="News Description" />

//                   <Controller
//                     name="description"
//                     control={control}
//                     defaultValue=""
//                     render={({ field }) => (
//                       <div
//                         className="rounded-3 overflow-hidden shadow-sm"
//                         style={{ border: "1px solid #e2e8f0" }}
//                       >
//                         <ReactQuill
//                           {...field}
//                           theme="snow"
//                           modules={modules}
//                           formats={formats}
//                           className="bg-white"
//                           onChange={(content) => field.onChange(content)}
//                           style={{ minHeight: "200px" }}
//                           placeholder="Write your video description here..."
//                         />
//                       </div>
//                     )}
//                   />
//                 </div>
//               </div>

//               {/* SEO Section Card */}
//               <div
//                 className="card shadow-lg border-0 mb-4"
//                 style={{ borderRadius: "20px", overflow: "hidden" }}
//               >
//                 <div
//                   className="card-header text-white py-3"
//                   style={{
//                     background:
//                       "linear-gradient(135deg, #30cfd0 0%, #330867 100%)",
//                   }}
//                 >
//                   <h5 className="mb-0 d-flex align-items-center">
//                     <i className="bi bi-search me-2"></i>
//                     SEO Optimization
//                   </h5>
//                 </div>
//                 <div className="card-body p-4">
//                   <div className="row g-3">
//                     <div className="col-12">
//                       <Input
//                         icon="title"
//                         {...register("seoTitle")}
//                         error={errors.name?.message}
//                         type="text"
//                         placeholder="Enter SEO friendly title..."
//                         label="SEO Title"
//                       />
//                     </div>
//                     <div className="col-12">
//                       <Label
//                         className="fw-bold mb-2"
//                         label="Meta Description"
//                       />
//                       <Controller
//                         name="metaDescription"
//                         control={control}
//                         defaultValue=""
//                         render={({ field }) => (
//                           <ReactQuill
//                             {...field}
//                             theme="snow"
//                             className="bg-white"
//                             style={{ borderRadius: "10px" }}
//                             onChange={(content) => field.onChange(content)}
//                           />
//                         )}
//                       />
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Sidebar - Right Column */}
//             <div className="col-lg-4">
//               <div
//                 className="card shadow-lg border-0 mb-4"
//                 style={{ borderRadius: "20px", overflow: "hidden" }}
//               >
//                 <div
//                   className="card-header text-white py-3"
//                   style={{
//                     background:
//                       "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                   }}
//                 >
//                   <h5 className="mb-0 d-flex align-items-center">
//                     <i className="bi bi-pencil-square me-2"></i>
//                     Publish Schedule
//                   </h5>
//                 </div>
//                 <div className="card-body p-4">
//                   <div className="row g-3">
//                     <div className="col-12 mt-3">
//                       <Input
//                         icon="calendar"
//                         {...register("dateTime")}
//                         error={errors.dateTime?.message}
//                         type="datetime-local"
//                         label="Publish Date & Time"
//                       />
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Reporter & Status Card */}
//               <div
//                 className="card shadow-lg border-0 mb-4"
//                 style={{ borderRadius: "20px", overflow: "hidden" }}
//               >
//                 <div
//                   className="card-header text-white py-3"
//                   style={{
//                     background:
//                       "linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)",
//                   }}
//                 >
//                   <h5 className="mb-0 text-dark d-flex align-items-center">
//                     <i className="bi bi-person-badge me-2"></i>
//                     Reporter & Status
//                   </h5>
//                 </div>
//                 <div className="card-body p-4">
//                   <div className="mb-3">
//                     <Controller
//                       name="repoters"
//                       control={control}
//                       render={({ field }) => (
//                         <Select
//                           {...field}
//                           isClearable
//                           options={transformedUser}
//                           placeholder="Select a Reporter"
//                           label="Reporter"
//                           menuPortalTarget={document.body}
//                           styles={{
//                             menuPortal: (base) => ({ ...base, zIndex: 9999 }),
//                           }}
//                         />
//                       )}
//                     />
//                   </div>
//                   <div>
//                     <Controller
//                       name="status"
//                       control={control}
//                       render={({ field }) => (
//                         <Select
//                           {...field}
//                           isClearable
//                           options={transformedStatus}
//                           placeholder="active / inactive"
//                           label="Status"
//                           menuPortalTarget={document.body}
//                           styles={{
//                             menuPortal: (base) => ({ ...base, zIndex: 9999 }),
//                           }}
//                         />
//                       )}
//                     />
//                   </div>
//                 </div>
//               </div>

//               {/* Categories Card */}
//               <div
//                 className="card shadow-lg border-0 mb-4"
//                 style={{ borderRadius: "20px", overflow: "visible" }}
//               >
//                 <div
//                   className="card-header text-white py-3"
//                   style={{
//                     background:
//                       "linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%)",
//                   }}
//                 >
//                   <h5 className="mb-0 d-flex align-items-center">
//                     <i className="bi bi-folder me-2"></i>
//                     Categories
//                   </h5>
//                 </div>
//                 <div
//                   className="card-body p-4"
//                   style={{ position: "relative", zIndex: 1 }}
//                 >
//                   <Controller
//                     name="selectedCategories"
//                     control={control}
//                     defaultValue={[]}
//                     render={({ field }) => {
//                       const handleCheckboxChange = (e) => {
//                         const { value, checked } = e.target;
//                         const newValue = checked
//                           ? [...field.value, value]
//                           : field.value.filter((id) => id !== value);
//                         field.onChange(newValue);
//                       };

//                       return (
//                         <div
//                           style={{ maxHeight: "300px", overflowY: "auto" }}
//                           className="custom-scrollbar p-3"
//                         >
//                           {categoryhData?.categorys?.map((category) => (
//                             <div
//                               className={`form-check mb-2 p-3 rounded ${
//                                 field.value.includes(category._id)
//                                   ? "bg-primary bg-opacity-10 border border-primary"
//                                   : "bg-light"
//                               }`}
//                               key={category._id}
//                               style={{
//                                 cursor: "pointer",
//                                 transition: "all 0.2s ease",
//                                 border: field.value.includes(category._id)
//                                   ? "2px solid"
//                                   : "1px solid transparent",
//                               }}
//                             >
//                               <input
//                                 className="form-check-input"
//                                 type="checkbox"
//                                 id={`checkbox-${category._id}`}
//                                 value={category._id}
//                                 checked={field.value.includes(category._id)}
//                                 onChange={handleCheckboxChange}
//                                 style={{
//                                   width: "20px",
//                                   height: "20px",
//                                   cursor: "pointer",
//                                 }}
//                               />
//                               <label
//                                 className={`form-check-label fw-medium ms-2 ${
//                                   field.value.includes(category._id)
//                                     ? "text-primary fw-bold"
//                                     : ""
//                                 }`}
//                                 htmlFor={`checkbox-${category._id}`}
//                                 style={{
//                                   cursor: "pointer",
//                                   fontSize: "0.95rem",
//                                 }}
//                               >
//                                 {field.value.includes(category._id) ? "✓ " : ""}
//                                 {category.name}
//                               </label>
//                             </div>
//                           ))}
//                         </div>
//                       );
//                     }}
//                   />
//                 </div>
//               </div>

//               {/* Topics Card */}
//               <div
//                 className="card shadow-lg border-0 mb-4"
//                 style={{ borderRadius: "20px", overflow: "visible" }}
//               >
//                 <div
//                   className="card-header text-white py-3"
//                   style={{
//                     background:
//                       "linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)",
//                   }}
//                 >
//                   <h5 className="mb-0 text-dark d-flex align-items-center">
//                     <i className="bi bi-tags me-2"></i>
//                     Topics
//                   </h5>
//                 </div>
//                 <div
//                   className="card-body p-4"
//                   style={{ position: "relative", zIndex: 1 }}
//                 >
//                   <Controller
//                     name="selectedTopic"
//                     control={control}
//                     defaultValue={[]}
//                     render={({ field }) => {
//                       const handleCheckboxChange = (e) => {
//                         const { value, checked } = e.target;
//                         const newValue = checked
//                           ? [...field.value, value]
//                           : field.value.filter((id) => id !== value);
//                         field.onChange(newValue);
//                       };

//                       return (
//                         <div
//                           style={{ maxHeight: "300px", overflowY: "auto" }}
//                           className="custom-scrollbar p-3"
//                         >
//                           {topicData?.categorys?.map((category) => (
//                             <div
//                               className={`form-check mb-2 p-3 rounded ${
//                                 field.value.includes(category._id)
//                                   ? "bg-warning bg-opacity-10 border border-warning"
//                                   : "bg-light"
//                               }`}
//                               key={category._id}
//                               style={{
//                                 cursor: "pointer",
//                                 transition: "all 0.2s ease",
//                                 border: field.value.includes(category._id)
//                                   ? "2px solid"
//                                   : "1px solid transparent",
//                               }}
//                             >
//                               <input
//                                 className="form-check-input"
//                                 type="checkbox"
//                                 id={`topic-checkbox-${category._id}`}
//                                 value={category._id}
//                                 checked={field.value.includes(category._id)}
//                                 onChange={handleCheckboxChange}
//                                 style={{
//                                   width: "20px",
//                                   height: "20px",
//                                   cursor: "pointer",
//                                 }}
//                               />
//                               <label
//                                 className={`form-check-label fw-medium ms-2 ${
//                                   field.value.includes(category._id)
//                                     ? "text-warning fw-bold"
//                                     : ""
//                                 }`}
//                                 htmlFor={`topic-checkbox-${category._id}`}
//                                 style={{
//                                   cursor: "pointer",
//                                   fontSize: "0.95rem",
//                                 }}
//                               >
//                                 {field.value.includes(category._id) ? "✓ " : ""}
//                                 {category.name}
//                               </label>
//                             </div>
//                           ))}
//                         </div>
//                       );
//                     }}
//                   />
//                 </div>
//               </div>

//               {/* Featured Image Card */}
//               <div
//                 className="card shadow-lg border-0 mb-4"
//                 style={{ borderRadius: "20px", overflow: "hidden" }}
//               >
//                 <div
//                   className="card-header text-white py-3"
//                   style={{
//                     background:
//                       "linear-gradient(135deg, #a1c4fd 0%, #c2e9fb 100%)",
//                   }}
//                 >
//                   <h5 className="mb-0 text-dark d-flex align-items-center">
//                     <i className="bi bi-image me-2"></i>
//                     Featured Image
//                   </h5>
//                 </div>
//                 <div className="card-body p-4">
//                   <Controller
//                     name="image"
//                     control={control}
//                     defaultValue={null}
//                     render={({ field }) => (
//                       <SmartImageUpload
//                         multiple={false}
//                         limit={1}
//                         files={field.value ? [field.value] : []}
//                         onSelectFiles={(url) => {
//                           console.log(url.data[0].image);
//                           field.onChange(url.data[0].image || "");
//                         }}
//                       />
//                     )}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Submit Button */}
//           <div className="row mt-5">
//             <div className="col-12">
//               <div className="d-grid gap-2">
//                 <BrandButton
//                   type="submit"
//                   title={loading ? "Saving Changes..." : "💾 Save & Publish"}
//                   className="btn-lg shadow-lg"
//                   style={{
//                     borderRadius: "15px",
//                     background:
//                       "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                     border: "none",
//                     padding: "15px",
//                     fontSize: "1.2rem",
//                     fontWeight: "bold",
//                   }}
//                 />
//               </div>
//             </div>
//           </div>
//         </form>

//         <style jsx>{`
//           .hover-bg-light:hover {
//             background-color: #f8f9fa;
//             transition: background-color 0.2s ease;
//           }
//           .custom-scrollbar::-webkit-scrollbar {
//             width: 8px;
//           }
//           .custom-scrollbar::-webkit-scrollbar-track {
//             background: #f1f1f1;
//             border-radius: 10px;
//           }
//           .custom-scrollbar::-webkit-scrollbar-thumb {
//             background: #888;
//             border-radius: 10px;
//           }
//           .custom-scrollbar::-webkit-scrollbar-thumb:hover {
//             background: #555;
//           }
//           .card {
//             transition: transform 0.2s ease, box-shadow 0.2s ease;
//           }
//           .card:hover {
//             transform: translateY(-5px);
//             box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15) !important;
//           }
//         `}</style>
//       </div>
//     </div>
//   );
// }

// export default RoleForm;

import { useState, useEffect } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useMutation, useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { useQueryClient } from "@tanstack/react-query";
import { useQuill } from "react-quilljs"; // ✅ Changed
import "quill/dist/quill.snow.css"; // ✅ Added CSS import
import { useForm, Controller } from "react-hook-form";
import Checkbox from "../../ChildComponents/Checkbox";
import SmartImageUpload from "../../ChildComponents/SmartImageUploader";
import Input from "../../ChildComponents/Input";
import BrandButton from "../../ChildComponents/BrandButton";
import Select from "../../ChildComponents/Select";
import Label from "../../ChildComponents/Label";
import { newsSchema } from "../validation/newsValidation";
import { useGetlocation } from "../../store/api/locationApi";
import { useGetCategory } from "../../store/api/categoryApi";
import { useGetTopic } from "../../store/api/topicApi";
import { useGetUser } from "../../store/api/authApi";
import { useCreateNews, useUpdateNews } from "../../store/api/newsApi";

function RoleForm({ data, editId, onSuccessCreated }) {
  const getLocalDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  const formattedNow = getLocalDateTime();

  // ✅ Quill modules configuration
  const modules = {
    toolbar: [
      [{ font: [] }],
      [{ size: ["small", false, "large", "huge"] }],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ color: [] }, { background: [] }],
      [{ script: "sub" }, { script: "super" }],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ align: [] }],
      [{ direction: "rtl" }],
      ["link", "image", "video"],
      ["blockquote", "code-block"],
      ["clean"],
    ],
    clipboard: {
      matchVisual: false,
    },
  };

  // ✅ Setup two Quill editors - one for description, one for meta
  const { quill: descriptionQuill, quillRef: descriptionRef } = useQuill({
    modules,
  });
  const { quill: metaQuill, quillRef: metaRef } = useQuill();

  // ✅ States for editor content
  const [description, setDescription] = useState("");
  const [metaDescription, setMetaDescription] = useState("");

  const getUser = useGetUser();
  const {
    data: userData,
    isLoading: isUserLoading,
    error: UserError,
  } = useQuery({ queryKey: "users", queryFn: getUser });

  const transformedUser = userData?.user?.map((user) => ({
    label: user.fullName,
    value: user._id,
  }));

  const getLocation = useGetlocation();
  const {
    data: locationData,
    isLoading: isLocationLoading,
    error: locationError,
  } = useQuery({ queryKey: "location", queryFn: getLocation });

  const transformedDivistion = locationData?.division?.map((i) => ({
    label: i.name,
    value: i._id,
    myId: i.id,
  }));
  const transformedDistrict = locationData?.district?.map((i) => ({
    label: i.name,
    value: i._id,
    dId: i.division_id,
    myid: i.id,
  }));
  const transformedSubDistrict = locationData?.upazila?.map((i) => ({
    label: i.name,
    value: i._id,
    dId: i.district_id,
    myid: i.id,
  }));
  const transformedStatus = [
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" },
  ];

  const getCategory = useGetCategory();
  const {
    data: categoryhData,
    isLoading: isCategoryLoading,
    error: categoryError,
  } = useQuery({ queryKey: "category", queryFn: getCategory });

  const getTopic = useGetTopic();
  const {
    data: topicData,
    isLoading: istopicLoading,
    error: topicError,
  } = useQuery({ queryKey: "topic", queryFn: getTopic });

  const transformedTopics = topicData?.topics?.map((topic) => ({
    label: topic.name,
    value: topic._id,
  }));

  const updateNews = useUpdateNews(editId?._id);

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    reset,
    watch,
    setValue,
  } = useForm({
    resolver: yupResolver(newsSchema),
    defaultValues: {
      dateTime: formattedNow,
    },
  });

  // ✅ Handle Quill text changes for description
  useEffect(() => {
    if (descriptionQuill) {
      descriptionQuill.on("text-change", () => {
        const content = descriptionQuill.root.innerHTML;
        setDescription(content);
        setValue("description", content);
      });
    }
  }, [descriptionQuill, setValue]);

  // ✅ Handle Quill text changes for meta description
  useEffect(() => {
    if (metaQuill) {
      metaQuill.on("text-change", () => {
        const content = metaQuill.root.innerHTML;
        setMetaDescription(content);
        setValue("metaDescription", content);
      });
    }
  }, [metaQuill, setValue]);

  // ✅ Load edit data
  useEffect(() => {
    if (editId) {
      const selectedDivision = transformedDivistion?.find(
        (item) => item.value === editId.division
      );
      const selectedDistrict = transformedDistrict?.find(
        (item) => item.value === editId.district
      );
      const selectedSubDistrict = transformedSubDistrict?.find(
        (item) => item.value === editId.upazila
      );
      const selectedReporter = transformedUser?.find(
        (item) => item.value === editId.reporters
      );
      const selectedStatus = transformedStatus?.find(
        (item) => item.value === editId.status
      );

      const selectedCategories =
        editId.categoryList?.map((cat) => cat._id) || [];

      const selectedTopic = editId.topicList?.filter((catId) =>
        topicData?.categorys?.some((cat) => cat._id === catId)
      );

      reset({
        title: editId.title || "",
        subTitle: editId.subTitle || "",
        division: selectedDivision || null,
        district: selectedDistrict || null,
        subDistrict: selectedSubDistrict || null,
        repoters: selectedReporter || null,
        status: selectedStatus || null,
        selectedCategories: selectedCategories || [],
        selectedTopic: selectedTopic || [],
        description: editId.discription || "",
        seoTitle: editId.metaTitle || "",
        metaDescription: editId.metaDiscription || "",
        image: editId.image ? `${editId.image}` : null,
        leadNews: editId.leadNews || false,
        liveNews: editId.liveNews || false,
        categoryPin: editId.categoryPin || false,
        topNews: editId.topNews || false,
        dateTime: editId.publishDate
          ? new Date(editId.publishDate).toISOString().slice(0, 16)
          : formattedNow,
      });

      // ✅ Load content into Quill editors
      if (descriptionQuill && editId.discription) {
        descriptionQuill.clipboard.dangerouslyPasteHTML(editId.discription);
      }
      if (metaQuill && editId.metaDiscription) {
        metaQuill.clipboard.dangerouslyPasteHTML(editId.metaDiscription);
      }

      setEdited(true);
    }
  }, [editId, reset, descriptionQuill, metaQuill]);

  // ✅ Reset form when not editing
  useEffect(() => {
    if (!editId) {
      reset({
        title: "",
        subTitle: "",
        division: null,
        district: null,
        subDistrict: null,
        repoters: null,
        status: null,
        selectedCategories: [],
        selectedTopic: [],
        description: "",
        seoTitle: "",
        metaDescription: "",
        image: null,
        leadNews: false,
        liveNews: false,
        categoryPin: false,
        topNews: false,
        dateTime: formattedNow,
      });

      // ✅ Clear Quill editors
      if (descriptionQuill) {
        descriptionQuill.setText("");
      }
      if (metaQuill) {
        metaQuill.setText("");
      }

      setEdited(false);
    }
  }, [editId, reset, descriptionQuill, metaQuill]);

  const createNews = useCreateNews();
  const queryClient = useQueryClient();
  const [loading, setLoading] = useState(false);
  const [edited, setEdited] = useState(editId ? true : false);

  const mutation = useMutation({
    mutationFn: (data) => {
      return editId ? updateNews(data) : createNews(data);
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries(["news"]);
      setLoading(false);
      toast.success("Created Successfully");
      reset();

      // ✅ Clear Quill editors after success
      if (descriptionQuill) {
        descriptionQuill.setText("");
      }
      if (metaQuill) {
        metaQuill.setText("");
      }

      onSuccessCreated(1);
    },
    onError: (error) => {
      toast.error(error.message || "Something went wrong!");
      setLoading(false);
    },
  });

  const onSubmit = (formData) => {
    setLoading(true);
    try {
      const data = new FormData();

      if (!formData.title?.trim()) {
        toast.warning("Title is required!");
        setLoading(false);
        return;
      }

      if (!formData.repoters || !formData.repoters.value) {
        toast.warning("Reporter is required!");
        setLoading(false);
        return;
      }

      // ✅ Use editor content state
      if (!description?.trim()) {
        toast.warning("Description is required!");
        setLoading(false);
        return;
      }

      if (
        !formData.selectedCategories ||
        formData.selectedCategories.length === 0
      ) {
        toast.warning("At least one category is required!");
        setLoading(false);
        return;
      }

      if (!formData.image) {
        toast.warning("Image is required!");
        setLoading(false);
        return;
      }

      data.append("title", formData.title);
      data.append("reporters", formData.repoters.value);
      data.append("discription", description || formData.description); // ✅ Use state
      formData.selectedCategories.forEach((catId) => {
        data.append("categoryList", catId);
      });
      data.append("image", formData.image);

      if (formData.subTitle) data.append("subTitle", formData.subTitle);
      if (formData.selectedTopic?.length > 0) {
        formData.selectedTopic.forEach((catId) => {
          data.append("topicList", catId);
        });
      }
      if (formData.seoTitle) data.append("metaTitle", formData.seoTitle);
      if (metaDescription)
        // ✅ Use state
        data.append("metaDiscription", metaDescription);
      if (formData.division?.value)
        data.append("division", formData.division.value);
      if (formData.district?.value)
        data.append("district", formData.district.value);
      if (formData.subDistrict?.value)
        data.append("upazila", formData.subDistrict.value);
      if (formData.status?.value) data.append("status", formData.status.value);
      data.append("leadNews", formData.leadNews);
      data.append("liveNews", formData.liveNews);
      data.append("categoryPin", formData.categoryPin);
      data.append("topNews", formData.topNews);
      data.append("dateTime", formData.dateTime);

      mutation.mutate(data);
    } catch (error) {
      setLoading(false);
      console.error("Caught error in handleSubmit:", error.message);
      toast.error(error.message);
    }
  };

  return (
    <div
      className="container-fluid"
      style={{
        background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
        minHeight: "100vh",
        padding: "2rem 0",
      }}
    >
      <div className="container-fluid">
        {/* Header */}
        <div className="mb-5">
          <h1 className="display-4 fw-bold text-dark mb-2">
            {editId ? "✏️ Edit News Article" : "📝 Create News Article"}
          </h1>
          <p className="lead text-muted">
            Fill in the details to publish your news story
          </p>
        </div>

        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="row g-4">
            {/* Main Content Area - Left Column */}
            <div className="col-lg-8">
              {/* Title Section Card */}
              <div
                className="card shadow-lg border-0 mb-4"
                style={{ borderRadius: "20px", overflow: "hidden" }}
              >
                <div
                  className="card-header text-white py-3"
                  style={{
                    background:
                      "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  }}
                >
                  <h5 className="mb-0 d-flex align-items-center">
                    <i className="bi bi-pencil-square me-2"></i>
                    Article Details
                  </h5>
                </div>
                <div className="card-body p-4">
                  <div className="row g-3">
                    <div className="col-12">
                      <Input
                        icon="title"
                        {...register("title")}
                        error={errors.name?.message}
                        type="text"
                        placeholder="Enter compelling news title..."
                        label="News Title"
                      />
                    </div>

                    <div className="col-12">
                      <Input
                        icon="title"
                        {...register("subTitle")}
                        error={errors.name?.message}
                        type="text"
                        placeholder="Add subtitle for context..."
                        label="News Subtitle"
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Status Toggles Card */}
              <div
                className="card shadow-lg border-0 mb-4"
                style={{ borderRadius: "20px", overflow: "hidden" }}
              >
                <div
                  className="card-header text-white py-3"
                  style={{
                    background:
                      "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
                  }}
                >
                  <h5 className="mb-0 d-flex align-items-center">
                    <i className="bi bi-toggles me-2"></i>
                    Publication Settings
                  </h5>
                </div>
                <div className="card-body p-4">
                  <div className="row g-4">
                    <div className="col-md-6 col-lg-3">
                      <div className="p-3 bg-light rounded-3 h-100">
                        <Controller
                          name="leadNews"
                          control={control}
                          defaultValue={false}
                          render={({ field }) => (
                            <Checkbox
                              id="leadNews"
                              title=" Lead News"
                              checked={field.value}
                              onChange={(e) => field.onChange(e.target.checked)}
                            />
                          )}
                        />
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-3">
                      <div className="p-3 bg-light rounded-3 h-100">
                        <Controller
                          name="liveNews"
                          control={control}
                          defaultValue={false}
                          render={({ field }) => (
                            <Checkbox
                              id="liveNews"
                              title=" Live News"
                              checked={field.value}
                              onChange={(e) => field.onChange(e.target.checked)}
                            />
                          )}
                        />
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-3">
                      <div className="p-3 bg-light rounded-3 h-100">
                        <Controller
                          name="categoryPin"
                          control={control}
                          defaultValue={false}
                          render={({ field }) => (
                            <Checkbox
                              id="CategoryPin"
                              title=" Category Pin"
                              checked={field.value}
                              onChange={(e) => field.onChange(e.target.checked)}
                            />
                          )}
                        />
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-3">
                      <div className="p-3 bg-light rounded-3 h-100">
                        <Controller
                          name="topNews"
                          control={control}
                          defaultValue={false}
                          render={({ field }) => (
                            <Checkbox
                              id="topNews"
                              title=" Top News"
                              checked={field.value}
                              onChange={(e) => field.onChange(e.target.checked)}
                            />
                          )}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Location Section Card */}
              <div
                className="card shadow-lg border-0 mb-4"
                style={{ borderRadius: "20px", overflow: "hidden" }}
              >
                <div
                  className="card-header text-white py-3"
                  style={{
                    background:
                      "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
                  }}
                >
                  <h5 className="mb-0 d-flex align-items-center">
                    <i className="bi bi-geo-alt me-2"></i>
                    Location Information
                  </h5>
                </div>
                <div className="card-body p-4">
                  <div className="row g-3">
                    <div className="col-md-4">
                      <Controller
                        name="division"
                        control={control}
                        render={({ field }) => (
                          <Select
                            {...field}
                            isClearable
                            options={transformedDivistion}
                            placeholder="Select a Division"
                            label="Division"
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            }}
                          />
                        )}
                      />
                    </div>
                    <div className="col-md-4">
                      <Controller
                        name="district"
                        control={control}
                        render={({ field }) => (
                          <Select
                            {...field}
                            isClearable
                            options={transformedDistrict?.filter(
                              (district) =>
                                !watch("division") ||
                                district?.dId === watch("division")?.myId
                            )}
                            placeholder="Select a District"
                            label="District"
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            }}
                          />
                        )}
                      />
                    </div>
                    <div className="col-md-4">
                      <Controller
                        name="subDistrict"
                        control={control}
                        render={({ field }) => (
                          <Select
                            {...field}
                            isClearable
                            options={transformedSubDistrict?.filter(
                              (upazila) =>
                                !watch("district") ||
                                upazila?.dId === watch("district")?.myid
                            )}
                            placeholder="Select an Upazila"
                            label="Upazila"
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            }}
                          />
                        )}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Content Editor Card */}
              <div
                className="card shadow-lg border-0 mb-4"
                style={{ borderRadius: "20px", overflow: "hidden" }}
              >
                <div
                  className="card-header text-white py-3"
                  style={{
                    background:
                      "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
                  }}
                >
                  <h5 className="mb-0 d-flex align-items-center">
                    <i className="bi bi-file-text me-2"></i>
                    Article Content
                  </h5>
                </div>
                <div className="card-body p-4">
                  <Label className="fw-bold mb-2" label="News Description" />
                  {/* ✅ Replace ReactQuill with useQuill */}
                  <div
                    className="rounded-3 overflow-hidden shadow-sm"
                    style={{ border: "1px solid #e2e8f0", minHeight: "300px" }}
                  >
                    <div ref={descriptionRef} />
                  </div>
                  {errors.description && (
                    <p className="text-danger mt-2">
                      {errors.description.message}
                    </p>
                  )}
                </div>
              </div>

              {/* SEO Section Card */}
              <div
                className="card shadow-lg border-0 mb-4"
                style={{ borderRadius: "20px", overflow: "hidden" }}
              >
                <div
                  className="card-header text-white py-3"
                  style={{
                    background:
                      "linear-gradient(135deg, #30cfd0 0%, #330867 100%)",
                  }}
                >
                  <h5 className="mb-0 d-flex align-items-center">
                    <i className="bi bi-search me-2"></i>
                    SEO Optimization
                  </h5>
                </div>
                <div className="card-body p-4">
                  <div className="row g-3">
                    <div className="col-12">
                      <Input
                        icon="title"
                        {...register("seoTitle")}
                        error={errors.name?.message}
                        type="text"
                        placeholder="Enter SEO friendly title..."
                        label="SEO Title"
                      />
                    </div>
                    <div className="col-12">
                      <Label
                        className="fw-bold mb-2"
                        label="Meta Description"
                      />
                      {/* ✅ Replace ReactQuill with useQuill */}
                      <div
                        className="rounded-3 overflow-hidden"
                        style={{
                          border: "1px solid #e2e8f0",
                          minHeight: "150px",
                        }}
                      >
                        <div ref={metaRef} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Sidebar - Right Column */}
            <div className="col-lg-4">
              <div
                className="card shadow-lg border-0 mb-4"
                style={{ borderRadius: "20px", overflow: "hidden" }}
              >
                <div
                  className="card-header text-white py-3"
                  style={{
                    background:
                      "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  }}
                >
                  <h5 className="mb-0 d-flex align-items-center">
                    <i className="bi bi-pencil-square me-2"></i>
                    Publish Schedule
                  </h5>
                </div>
                <div className="card-body p-4">
                  <div className="row g-3">
                    <div className="col-12 mt-3">
                      <Input
                        icon="calendar"
                        {...register("dateTime")}
                        error={errors.dateTime?.message}
                        type="datetime-local"
                        label="Publish Date & Time"
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Reporter & Status Card */}
              <div
                className="card shadow-lg border-0 mb-4"
                style={{ borderRadius: "20px", overflow: "hidden" }}
              >
                <div
                  className="card-header text-white py-3"
                  style={{
                    background:
                      "linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)",
                  }}
                >
                  <h5 className="mb-0 text-dark d-flex align-items-center">
                    <i className="bi bi-person-badge me-2"></i>
                    Reporter & Status
                  </h5>
                </div>
                <div className="card-body p-4">
                  <div className="mb-3">
                    <Controller
                      name="repoters"
                      control={control}
                      render={({ field }) => (
                        <Select
                          {...field}
                          isClearable
                          options={transformedUser}
                          placeholder="Select a Reporter"
                          label="Reporter"
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          }}
                        />
                      )}
                    />
                  </div>
                  <div>
                    <Controller
                      name="status"
                      control={control}
                      render={({ field }) => (
                        <Select
                          {...field}
                          isClearable
                          options={transformedStatus}
                          placeholder="active / inactive"
                          label="Status"
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          }}
                        />
                      )}
                    />
                  </div>
                </div>
              </div>

              {/* Categories Card */}
              <div
                className="card shadow-lg border-0 mb-4"
                style={{ borderRadius: "20px", overflow: "visible" }}
              >
                <div
                  className="card-header text-white py-3"
                  style={{
                    background:
                      "linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%)",
                  }}
                >
                  <h5 className="mb-0 d-flex align-items-center">
                    <i className="bi bi-folder me-2"></i>
                    Categories
                  </h5>
                </div>
                <div
                  className="card-body p-4"
                  style={{ position: "relative", zIndex: 1 }}
                >
                  <Controller
                    name="selectedCategories"
                    control={control}
                    defaultValue={[]}
                    render={({ field }) => {
                      const handleCheckboxChange = (e) => {
                        const { value, checked } = e.target;
                        const newValue = checked
                          ? [...field.value, value]
                          : field.value.filter((id) => id !== value);
                        field.onChange(newValue);
                      };

                      return (
                        <div
                          style={{ maxHeight: "300px", overflowY: "auto" }}
                          className="custom-scrollbar p-3"
                        >
                          {categoryhData?.categorys?.map((category) => (
                            <div
                              className={`form-check mb-2 p-3 rounded ${
                                field.value.includes(category._id)
                                  ? "bg-primary bg-opacity-10 border border-primary"
                                  : "bg-light"
                              }`}
                              key={category._id}
                              style={{
                                cursor: "pointer",
                                transition: "all 0.2s ease",
                                border: field.value.includes(category._id)
                                  ? "2px solid"
                                  : "1px solid transparent",
                              }}
                            >
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id={`checkbox-${category._id}`}
                                value={category._id}
                                checked={field.value.includes(category._id)}
                                onChange={handleCheckboxChange}
                                style={{
                                  width: "20px",
                                  height: "20px",
                                  cursor: "pointer",
                                }}
                              />
                              <label
                                className={`form-check-label fw-medium ms-2 ${
                                  field.value.includes(category._id)
                                    ? "text-primary fw-bold"
                                    : ""
                                }`}
                                htmlFor={`checkbox-${category._id}`}
                                style={{
                                  cursor: "pointer",
                                  fontSize: "0.95rem",
                                }}
                              >
                                {field.value.includes(category._id) ? "✓ " : ""}
                                {category.name}
                              </label>
                            </div>
                          ))}
                        </div>
                      );
                    }}
                  />
                </div>
              </div>

              {/* Topics Card */}
              <div
                className="card shadow-lg border"
                style={{ borderRadius: "20px", overflow: "visible" }}
              >
                <div
                  className="card-header text-white py-3"
                  style={{
                    background:
                      "linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)",
                  }}
                >
                  <h5 className="mb-0 text-dark d-flex align-items-center">
                    <i className="bi bi-tags me-2"></i>
                    Topics
                  </h5>
                </div>
                <div
                  className="card-body p-4"
                  style={{ position: "relative", zIndex: 1 }}
                >
                  <Controller
                    name="selectedTopic"
                    control={control}
                    defaultValue={[]}
                    render={({ field }) => {
                      const handleCheckboxChange = (e) => {
                        const { value, checked } = e.target;
                        const newValue = checked
                          ? [...field.value, value]
                          : field.value.filter((id) => id !== value);
                        field.onChange(newValue);
                      };

                      return (
                        <div
                          style={{ maxHeight: "300px", overflowY: "auto" }}
                          className="custom-scrollbar p-3"
                        >
                          {topicData?.categorys?.map((category) => (
                            <div
                              className={`form-check mb-2 p-3 rounded ${
                                field.value.includes(category._id)
                                  ? "bg-warning bg-opacity-10 border border-warning"
                                  : "bg-light"
                              }`}
                              key={category._id}
                              style={{
                                cursor: "pointer",
                                transition: "all 0.2s ease",
                                border: field.value.includes(category._id)
                                  ? "2px solid"
                                  : "1px solid transparent",
                              }}
                            >
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id={`topic-checkbox-${category._id}`}
                                value={category._id}
                                checked={field.value.includes(category._id)}
                                onChange={handleCheckboxChange}
                                style={{
                                  width: "20px",
                                  height: "20px",
                                  cursor: "pointer",
                                }}
                              />
                              <label
                                className={`form-check-label fw-medium ms-2 ${
                                  field.value.includes(category._id)
                                    ? "text-warning fw-bold"
                                    : ""
                                }`}
                                htmlFor={`topic-checkbox-${category._id}`}
                                style={{
                                  cursor: "pointer",
                                  fontSize: "0.95rem",
                                }}
                              >
                                {field.value.includes(category._id) ? "✓ " : ""}
                                {category.name}
                              </label>
                            </div>
                          ))}
                        </div>
                      );
                    }}
                  />
                </div>
              </div>

              {/* Featured Image Card */}
              <div
                className="card shadow-lg border-0 mb-4"
                style={{ borderRadius: "20px", overflow: "hidden" }}
              >
                <div
                  className="card-header text-white py-3"
                  style={{
                    background:
                      "linear-gradient(135deg, #a1c4fd 0%, #c2e9fb 100%)",
                  }}
                >
                  <h5 className="mb-0 text-dark d-flex align-items-center">
                    <i className="bi bi-image me-2"></i>
                    Featured Image
                  </h5>
                </div>
                <div className="card-body p-4">
                  <Controller
                    name="image"
                    control={control}
                    defaultValue={null}
                    render={({ field }) => (
                      <SmartImageUpload
                        multiple={false}
                        limit={1}
                        files={field.value ? [field.value] : []}
                        onSelectFiles={(url) => {
                          console.log(url.data[0].image);
                          field.onChange(url.data[0].image || "");
                        }}
                      />
                    )}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Submit Button */}
          <div className="row mt-5">
            <div className="col-12">
              <div className="d-grid gap-2">
                <BrandButton
                  type="submit"
                  title={loading ? "Saving Changes..." : "💾 Save & Publish"}
                  className="btn-lg shadow-lg"
                  style={{
                    borderRadius: "15px",
                    background:
                      "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    border: "none",
                    padding: "15px",
                    fontSize: "1.2rem",
                    fontWeight: "bold",
                  }}
                />
              </div>
            </div>
          </div>
        </form>

        <style jsx>{`
          .hover-bg-light:hover {
            background-color: #f8f9fa;
            transition: background-color 0.2s ease;
          }
          .custom-scrollbar::-webkit-scrollbar {
            width: 8px;
          }
          .custom-scrollbar::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 10px;
          }
          .custom-scrollbar::-webkit-scrollbar-thumb {
            background: #888;
            border-radius: 10px;
          }
          .custom-scrollbar::-webkit-scrollbar-thumb:hover {
            background: #555;
          }
          .card {
            transition: transform 0.2s ease, box-shadow 0.2s ease;
          }
          .card:hover {
            transform: translateY(-5px);
            box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15) !important;
          }
        `}</style>
      </div>
    </div>
  );
}

export default RoleForm;
